// File can't be stored in redux
let InitialFiles: File[] | null

// use this for setting initial files
export function setInitialFiles(files: File[]) {
  InitialFiles = files
}

// get initial files and reset
export function resetInitialFiles() {
  const _ = InitialFiles
  InitialFiles = null
  return _
}
